module.exports = __webpack_public_path__ + "img/car-11.9908d6e8.jpeg";